import { ButtonExcelForQuick } from 'components/DownloadExel'

import React from 'react'


const Heading = ({title,download=""}) => {


    return (
        <div className="contentHead">
            <h4>{title}</h4>
        </div>
    )
}

export default Heading